const phoneRules = {
  1: { min: 10, max: 10 }, // USA, Canada, Caribbean NANP
  7: { min: 10, max: 10 }, // Russia, Kazakhstan
  20: { min: 9, max: 10 }, // Egypt
  27: { min: 9, max: 9 }, // South Africa
  30: { min: 10, max: 10 }, // Greece
  31: { min: 9, max: 9 }, // Netherlands
  32: { min: 9, max: 9 }, // Belgium
  33: { min: 9, max: 9 }, // France
  34: { min: 9, max: 9 }, // Spain
  36: { min: 9, max: 9 }, // Hungary
  39: { min: 9, max: 10 }, // Italy
  40: { min: 9, max: 9 }, // Romania
  41: { min: 9, max: 12 }, // Switzerland
  43: { min: 10, max: 13 }, // Austria
  44: { min: 10, max: 10 }, // UK
  45: { min: 8, max: 8 }, // Denmark
  46: { min: 7, max: 13 }, // Sweden
  47: { min: 8, max: 8 }, // Norway
  48: { min: 9, max: 9 }, // Poland
  49: { min: 10, max: 11 }, // Germany

  // ---------- MIDDLE EAST ----------
  90: { min: 10, max: 10 }, // Turkey
  91: { min: 10, max: 10 }, // India
  92: { min: 10, max: 10 }, // Pakistan
  93: { min: 9, max: 9 }, // Afghanistan
  94: { min: 9, max: 9 }, // Sri Lanka
  95: { min: 9, max: 9 }, // Myanmar
  98: { min: 10, max: 10 }, // Iran
  971: { min: 9, max: 9 }, // UAE
  974: { min: 8, max: 8 }, // Qatar
  965: { min: 8, max: 8 }, // Kuwait
  973: { min: 8, max: 8 }, // Bahrain
  968: { min: 8, max: 8 }, // Oman
  966: { min: 9, max: 9 }, // Saudi Arabia

  // ---------- ASIA ----------
  81: { min: 10, max: 10 }, // Japan
  82: { min: 10, max: 11 }, // South Korea
  84: { min: 9, max: 10 }, // Vietnam
  86: { min: 11, max: 11 }, // China
  852: { min: 8, max: 8 }, // Hong Kong
  853: { min: 8, max: 8 }, // Macau
  855: { min: 8, max: 9 }, // Cambodia
  856: { min: 8, max: 10 }, // Laos
  60: { min: 9, max: 10 }, // Malaysia
  62: { min: 9, max: 12 }, // Indonesia
  63: { min: 10, max: 10 }, // Philippines
  65: { min: 8, max: 8 }, // Singapore
  66: { min: 9, max: 9 }, // Thailand

  // ---------- AFRICA ----------
  212: { min: 9, max: 9 }, // Morocco
  213: { min: 9, max: 9 }, // Algeria
  216: { min: 8, max: 8 }, // Tunisia
  218: { min: 9, max: 9 }, // Libya
  254: { min: 9, max: 9 }, // Kenya
  234: { min: 10, max: 11 }, // Nigeria
  260: { min: 9, max: 9 }, // Zambia
  255: { min: 9, max: 9 }, // Tanzania
  256: { min: 9, max: 9 }, // Uganda
  250: { min: 9, max: 9 }, // Rwanda

  // ---------- OCEANIA ----------
  61: { min: 9, max: 9 }, // Australia
  64: { min: 8, max: 10 }, // New Zealand
  679: { min: 7, max: 7 }, // Fiji
  675: { min: 8, max: 8 }, // PNG

  // ---------- SOUTH AMERICA ----------
  55: { min: 10, max: 11 }, // Brazil
  54: { min: 10, max: 10 }, // Argentina
  51: { min: 9, max: 9 }, // Peru
  57: { min: 10, max: 10 }, // Colombia
  58: { min: 10, max: 10 }, // Venezuela
  56: { min: 9, max: 9 }, // Chile

  // ---------- EXTRA ----------
  353: { min: 9, max: 9 }, // Ireland
  354: { min: 7, max: 7 }, // Iceland
  358: { min: 9, max: 12 }, // Finland
  370: { min: 8, max: 8 }, // Lithuania
  371: { min: 8, max: 8 }, // Latvia
  372: { min: 7, max: 8 }, // Estonia
  380: { min: 9, max: 9 }, // Ukraine
  381: { min: 8, max: 10 }, // Serbia
  385: { min: 8, max: 9 }, // Croatia
  386: { min: 8, max: 9 }, // Slovenia
  389: { min: 8, max: 9 }, // North Macedonia

  // DEFAULT rule (fallback)
  default: { min: 8, max: 15 },
};

export default phoneRules;
